import type { SVGProps } from "react";
export const Search = (props: SVGProps<SVGSVGElement>) => (
	<svg
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 24 24"
		aria-hidden={true}
		{...props}
	>
		<path
			d="M19.5421 20.577L13.2613 14.296C12.7613 14.7088 12.1863 15.0319 11.5363 15.2653C10.8863 15.4986 10.2139 15.6153 9.51906 15.6153C7.81139 15.6153 6.36523 15.023 5.18056 13.8385C3.99606 12.6538 3.40381 11.2077 3.40381 9.5C3.40381 7.79233 3.99606 6.34617 5.18056 5.1615C6.36523 3.977 7.81139 3.38475 9.51906 3.38475C11.2267 3.38475 12.6729 3.977 13.8576 5.1615C15.0421 6.34617 15.6343 7.79233 15.6343 9.5C15.6343 10.2142 15.5145 10.8963 15.2748 11.5463C15.035 12.1963 14.7151 12.7616 14.3151 13.2423L20.5958 19.523L19.5421 20.577ZM9.51906 14.1155C10.8076 14.1155 11.8989 13.6683 12.7931 12.774C13.6874 11.8798 14.1346 10.7885 14.1346 9.5C14.1346 8.2115 13.6874 7.12017 12.7931 6.226C11.8989 5.33167 10.8076 4.8845 9.51906 4.8845C8.23056 4.8845 7.13923 5.33167 6.24506 6.226C5.35073 7.12017 4.90356 8.2115 4.90356 9.5C4.90356 10.7885 5.35073 11.8798 6.24506 12.774C7.13923 13.6683 8.23056 14.1155 9.51906 14.1155Z"
			fill="currentColor"
		/>
	</svg>
);
